import { ApolloQueryResult } from "@apollo/client";
import { CompetencyMapsQuery, Exact } from "@generated/graphql";
import PageHeader from "components/PageHeader";
import { TestingSelectModalContext } from "context/testingSelectModalContext";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import CreateTemplate from "./CreateTemplate";

interface HeaderProps {
  refetch: (variables?: Partial<Exact<{ [key: string]: never }>>) => Promise<ApolloQueryResult<CompetencyMapsQuery>>;
}

const Header = ({ refetch }: HeaderProps) => {
  const navigate = useNavigate();
  const { handleOpen } = useContext(TestingSelectModalContext);

  const handleCreateButtonClick = () => {
    handleOpen({ navigate, competencyMapsList: true });
  };

  return (
    <PageHeader
      title='Карты компетенций'
      CustomButtons={<CreateTemplate refetch={refetch} />}
      mainButtonProps={{
        buttonText: "Создать тестирование",
        onClick: handleCreateButtonClick,
      }}
    />
  );
};

export default Header;
